import { authTypes } from "redux/auth/auth.types";
import { chatsTypes } from "./chats.types";

export const loginUserStart = (payload) => ({
  type: chatsTypes.LOGIN_USER_START,
  payload,
});

export const logoutUser = () => ({
  type: chatsTypes.LOGOUT_USER,
});

export const setIsConnected = (isConnected) => ({
  type: chatsTypes.SET_IS_CONNECTED,
  payload: isConnected,
});

export const loadAgent = (payload) => ({
  type: chatsTypes.LOAD_AGENT,
  payload,
});

export const connectChatsSocketStart = () => ({
  type: chatsTypes.CONNECT_CHATS_SOCKET,
});

export const fetchMoreConversations = ({ skip, convType, setLoading }) => ({
  type: chatsTypes.FETCH_MORE_OF_CONVS_LIST,
  payload: { skip, convType, setLoading },
});

export const sortOngoingConvsStart = (sort) => ({
  type: chatsTypes.SORT_ONGOING_CONVS_START,
  payload: sort,
});

export const setUSerChannels = (userChannels) => ({
  type: chatsTypes.SET_USER_CHANNELS,
  payload: userChannels,
});

export const updatePendingConversations = ({
  conversationId,
  conversation,
}) => ({
  type: chatsTypes.UPDATE_PENDING_CONVERSATIONS,
  payload: { conversationId, conversation },
});

// `updateNotSeen` field determines whether to update `notSeen` field or not
export const updateOngoingConversations = ({
  conversation,
  updateNotSeen = true,
}) => ({
  type: chatsTypes.UPDATE_ONGOING_CONVERSATIONS,
  payload: { conversation, updateNotSeen },
});

export const setSelectedConversations = (selectItem) => ({
  type: chatsTypes.SET_SELECTED_CONVERSATIONS,
  payload: selectItem,
});

export const setSelectedConversation = (conversationId) => ({
  type: chatsTypes.SET_SELECTED_CONVERSATION,
  payload: conversationId,
});

export const fetchConversationInfoStart = ({
  userId,
  conversationId,
  isPartnerChat,
  blockStatus,
  chatWithVisitor,
  setLoading = () => {},
}) => ({
  type: chatsTypes.FETCH_CONVERATION_INFO,
  payload: {
    userId,
    conversationId,
    isPartnerChat,
    setLoading,
    blockStatus,
    chatWithVisitor,
  },
});

export const setConversationUserInfo = ({ user, conversation }) => ({
  type: chatsTypes.SET_USER_CONVERSATION_INFO,
  payload: { user, conversation },
});

export const setContainerInfo = (containerInfo) => ({
  type: chatsTypes.SET_CONTAINER_INFO,
  payload: containerInfo,
});

export const setAgentInfo = (agentInfo) => ({
  type: chatsTypes.SET_AGENT_INFO,
  payload: agentInfo,
});

export const removeConversationNotSeen = ({
  conversationId,
  conversationStatus,
  isSelectdMessage,
}) => ({
  type: chatsTypes.REMOVE_CONVERSATION_NOT_SEEN,
  payload: { conversationId, conversationStatus, isSelectdMessage },
});

export const removeConversationNotSeenBadge = ({
  conversationId,
  conversationStatus,
}) => ({
  type: chatsTypes.REMOVE_CONVERSATION_NOT_SEEN_BADGE,
  payload: { conversationId, conversationStatus },
});

export const sendTextMessageStart = ({
  conversationId,
  clientId,
  message,
  chatWithVisitor,
  chatWithPartner,
}) => ({
  type: chatsTypes.SEND_TEXT_MESSAGE,
  payload: {
    conversationId,
    clientId,
    message,
    chatWithVisitor,
    chatWithPartner,
  },
});

export const sendFileMessageStart = ({
  conversationId,
  clientId,
  file,
  size,
}) => ({
  type: chatsTypes.SEND_FILE_MESSAGE,
  payload: { conversationId, clientId, file, size },
});

export const setDeliveredMessage = (messageTmpId) => ({
  type: chatsTypes.SET_DELIVERED_MESSAGE,
  payload: messageTmpId,
});

export const acceptConversationStart = ({ convId, userId, navigate }) => ({
  type: chatsTypes.ACCEPT_CONVERSATION_START,
  payload: { convId, userId, navigate },
});

export const closeConversationStart = ({
  userId,
  convId,
  action,
  onSuccess,
}) => ({
  type: chatsTypes.CLOSE_CONVERSATION_START,
  payload: { userId, convId, action, onSuccess },
});

export const addConversationToOngoings = (conversationId) => ({
  type: chatsTypes.ADD_CONVERSATION_TO_ONGOINGS,
  payload: conversationId,
});

export const removeClosedConversation = (conversationId) => ({
  type: chatsTypes.REMOVE_CLOSED_CONVERSATION,
  payload: conversationId,
});

export const setAgents = (agents) => ({
  type: chatsTypes.SET_AGENTS,
  payload: agents,
});

export const transferConversationStart = (conversationInfo) => ({
  type: chatsTypes.TRANSFER_CONVERSATION_START,
  payload: conversationInfo,
});

export const acceptTransferedConversationStart = (
  conversationInfo,
  navigate
) => ({
  type: chatsTypes.ACCEPT_TRANSFERED_CONVERSATION_START,
  payload: conversationInfo,
  navigate,
});

export const rejectTransferedConversationStart = (conversationInfo) => ({
  type: chatsTypes.REJECT_TRANSFERED_CONVERSATION_START,
  payload: conversationInfo,
});

export const removeTransferredChat = (convId) => ({
  type: chatsTypes.REMOVE_TRANSFERRED_CHAT,
  payload: convId,
});

export const setTransferedChat = (conversationInfo) => ({
  type: chatsTypes.SET_TRANSFERED_CHAT,
  payload: conversationInfo,
});

export const removeConversationFromList = ({ conversationId, listType }) => ({
  type: chatsTypes.REMOVE_CONV_FROM_LIST,
  payload: { conversationId, listType },
});

export const handleAcceptConversationStart = (conversationId) => ({
  type: chatsTypes.HANDLE_ACCEPTED_CONVERSATION,
  payload: conversationId,
});

export const setPretexts = (pretexts) => ({
  type: chatsTypes.SET_PRETEXTS,
  payload: pretexts,
});

export const addPretextsStart = (pretext) => ({
  type: chatsTypes.ADD_PRETEXT_START,
  payload: pretext,
});

export const removePretextsStart = (pretext) => ({
  type: chatsTypes.REMOVE_PRETEXT_START,
  payload: pretext,
});

export const editPretextsStart = (pretext) => ({
  type: chatsTypes.EDIT_PRETEXT_START,
  payload: pretext,
});

export const blockUserStart = (formData) => ({
  type: chatsTypes.BLOCK_USER_START,
  payload: formData,
});

export const updateUserInfo = ({ data, convType }) => ({
  type: chatsTypes.UPDATE_USER_INFO,
  payload: {
    data,
    convType,
  },
});

export const setUpdatedUser = (userInfo) => ({
  type: chatsTypes.SET_UPDATED_USER,
  payload: userInfo,
});

export const setIsLoggedInUser = (isLoggedInUser) => ({
  type: authTypes.SET_IS_LOGGED_IN_USER,
  payload: isLoggedInUser,
});

export const closeAllConversationsStart = (agentId) => ({
  type: chatsTypes.CLOSE_ALL_CONVERSATIONS,
  payload: agentId,
});

export const setAgentOnline = (isOnline) => ({
  type: chatsTypes.SET_AGENT_ONLINE,
  payload: isOnline,
});

export const addOnlineUser = (user) => ({
  type: chatsTypes.ADD_ONLINE_USER,
  payload: user,
});

export const removeOnlineUser = (userId) => ({
  type: chatsTypes.REMOVE_ONLINE_USER,
  payload: userId,
});

export const setOnlineUsersBadge = (count) => ({
  type: chatsTypes.SET_ONLINE_USERS_BADGE,
  payload: count,
});

export const setNewMessage = ({ conversationId, message }) => ({
  type: chatsTypes.SET_NEW_MESSAGE,
  payload: { conversationId, message },
});

export const chatWithOnlineUserStart = ({ userId, navigate }) => ({
  type: chatsTypes.CHAT_WITH_ONLINE_USER_START,
  payload: { userId, navigate },
});

export const chatWithPartnerStart = ({ partnerId, navigate }) => ({
  type: chatsTypes.CHAT_WITH_PARTNER_START,
  payload: {
    partnerId,
    navigate,
  },
});

export const setPartnerNewMessage = () => ({
  type: chatsTypes.SET_PARTNER_NEW_MESSAGE,
});

export const setNotifications = (notifications) => ({
  type: chatsTypes.SET_NOTIFICATIONS,
  payload: notifications,
});

export const playMessageNotificationSound = (message) => ({
  type: chatsTypes.PLAY_MESSAGE_NOTIFICATION_SOUND,
  payload: message,
});

export const playNewVisitorSound = () => ({
  type: chatsTypes.PLAY_NEW_VISITOR_SOUND,
});

export const updateNotificationSounds = (notificationSettings) => ({
  type: chatsTypes.UPDATE_NOTIFICATION_SOUNDS,
  payload: notificationSettings,
});

export const updateAgentProfile = (
  { agentInfo, newAvatar },
  setLoadingSubmit
) => ({
  type: chatsTypes.UPDATE_AGENT_PROFILE,
  payload: { agentInfo, newAvatar, setLoadingSubmit },
});

export const updateTelegramBot = (isActive) => ({
  type: chatsTypes.UPDATE_TELEGRAM_BOT,
  payload: isActive,
});

export const refreshAgentInfo = () => ({
  type: chatsTypes.REFRESH_AGENT_INFO,
});

export const setUnreadOngoingMessage = (hasUnreadMessage) => ({
  type: chatsTypes.SET_UNREAD_ONGOING_MESSAGE,
  payload: hasUnreadMessage,
});

export const setUnreadPendingMessage = (hasUnreadMessage) => ({
  type: chatsTypes.SET_UNREAD_PENDING_MESSAGE,
  payload: hasUnreadMessage,
});

export const fetchMoreMessages = ({ skip, conversationId }) => ({
  type: chatsTypes.FETCH_MORE_MESSAGES,
  payload: {
    skip,
    conversationId,
  },
});

export const setScrollToBottom = (isScroll) => ({
  type: chatsTypes.SET_SCROLL_TO_BOTTOM,
  payload: isScroll,
});

export const logoutSocket = (payload) => ({
  type: chatsTypes.LOGOUT_SOCKT,
  payload: payload,
});

export const setLoadingChats = (isLoading) => ({
  type: chatsTypes.SET_LOADING_CHATS,
  payload: isLoading,
});

export const setLoginLoading = (isLoading) => ({
  type: authTypes.SET_LOGIN_LOADING,
  payload: isLoading,
});

export const setTypingWord = (word) => ({
  type: chatsTypes.SET_TYPING_WORD,
  payload: word,
});

export const setResetPassLoading = (isLoading) => ({
  type: chatsTypes.SET_RESET_PASSWORD_lOADING,
  payload: isLoading,
});

export const resetPasswordStart = (formData) => ({
  type: chatsTypes.RESET_PASSWORD_START,
  payload: formData,
});

export const setIsReconnecting = (isReconnecting) => ({
  type: chatsTypes.SET_IS_RECONNECTING,
  payload: isReconnecting,
});

export const setOnlineUsersBadgeStart = () => ({
  type: chatsTypes.SET_ONLINE_USERS_BADGE_START,
});

export const fetchAgentsStart = () => ({
  type: chatsTypes.FETCH_AGENTS_START,
});

export const fetchOnlineUsersStart = ({ page, limit } = {}) => ({
  type: chatsTypes.FETCH_ONLINE_USERS_START,
  payload: { page, limit },
});

export const setLocale = (locale) => ({
  type: chatsTypes.SET_LOCALE,
  payload: locale,
});
export const setActingMessage = (message) => ({
  type: chatsTypes.SET_ACTING_MESSAGE,
  payload: message,
});

export const editMessageStart = (payload) => ({
  type: chatsTypes.EDIT_MESSAGE_START,
  payload: payload,
});

export const setEditedMessage = (msgContent, msgId) => ({
  type: chatsTypes.SET_EDITED_MESSAGE,
  payload: {
    msgContent,
    msgId,
  },
});

export const setSeenStatusForAllMessages = ({ conversationId, teamId }) => ({
  type: chatsTypes.SET_SEEN_STATUS_FOR_ALL_MESSAGES,
  payload: { conversationId, teamId },
});

export const setMessageId = ({ prevId, newId }) => ({
  type: chatsTypes.SET_MESSAGE_ID,
  payload: { prevId, newId },
});

// voice record
export const setAudioStream = (stream) => ({
  type: chatsTypes.SET_AUDIO_STREAM,
  payload: stream,
});

export const setRecordingAudio = (audio) => ({
  type: chatsTypes.SET_RECORDING_AUDIO,
  payload: audio,
});

export const setVoiceRecording = (isRecording) => ({
  type: chatsTypes.SET_VOICE_RECORDING,
  payload: isRecording,
});

export const resetVoiceRecordingData = () => ({
  type: chatsTypes.RESET_VOICE_RECORDING_DATA,
});

export const setConversationCharge = (count) => ({
  type: chatsTypes.SET_CONVERSATIONS_CHARGE,
  payload: count,
});

export const fetchUserRoadmap = (userId, setShowModal, showNotif = true) => ({
  type: chatsTypes.FETCH_USER_ROADMAP,
  payload: { userId, setShowModal, showNotif },
});

export const updateUserAvatarStart = (
  fileObj,
  conversationId,
  conversationType,
  userId
) => ({
  type: chatsTypes.UPDATE_USER_AVATAR,
  payload: {
    fileObj,
    conversationId,
    conversationType,
    userId,
  },
});

export const updateUserAvatarUploadProgress = (id, progress) => ({
  type: chatsTypes.SET_USER_AVATAR_UPLOAD_PROGRESS,
  payload: {
    id,
    progress,
  },
});

export const updateConversationAvatar = (
  conversationType,
  conversationId,
  progress,
  avatar
) => ({
  type: chatsTypes.UPDATE_CONVERSATION_AVATAR,
  payload: {
    conversationType,
    conversationId,
    progress,
    avatar,
  },
});

export const updateChatFileUploadProgress = (
  progress,
  conversationId,
  messageId
) => ({
  type: chatsTypes.UPDATE_CHAT_FILE_UPLOAD_PROGRESS,
  payload: {
    progress,
    conversationId,
    messageId,
  },
});

export const addPendingMessageToTheList = (message, conversationId) => ({
  type: chatsTypes.ADD_PENDING_MESSAGE_TO_THE_LIST,
  payload: { message, conversationId },
});

export const removeMessageFromPendingList = (conversationId, messageId) => ({
  type: chatsTypes.REMOVE_MESSAGE_FROM_PENDING_LIST,
  payload: { messageId, conversationId },
});

export const setConversationsList = ({ convType, data, totalCount }) => ({
  type: chatsTypes.SET_CONVERSATIONS_LIST,
  payload: { data, convType, totalCount },
});

export const setHasMoreToLoadConvs = ({ hasMore, convType }) => ({
  type: chatsTypes.SET_HAS_MORE_TO_LOAD,
  payload: { hasMoreToLoad: hasMore, convType },
});

export const transferConvToMe = ({ conversationId, clientId, navigate }) => ({
  type: chatsTypes.TRANSFER_CONVERSATION_TO_ME,
  payload: { conversationId, clientId, navigate },
});

export const setTeams = (teams) => ({
  type: chatsTypes.SET_TEAMS,
  payload: teams,
});

export const setBlockedUsersList = (blockedUsers) => ({
  type: chatsTypes.SET_BLOCKED_USERS_LIST,
  payload: blockedUsers,
});

export const unblockUserStart = ({ userId, ip }) => ({
  type: chatsTypes.UNBLOCK_USER,
  payload: { userId, ip },
});

export const setConversationWithBotStatus = ({ conversationId, status }) => ({
  type: chatsTypes.SET_CONVERSATION_WITH_BOT_STATUS,
  payload: { conversationId, status },
});

export const updatePendingConversationByNewBotMsg = ({
  conversationId,
  message,
}) => ({
  type: chatsTypes.UPDATE_PENDING_CONVERSATION_BY_BOT_NEW_MSG,
  payload: { conversationId, message },
});

export const getClosedConversation = ({ userId }) => ({
  type: chatsTypes.GET_CLOSED_CONVERSATION,
  payload: userId,
});

export const setNewOnlineUserConv = (userId) => ({
  type: chatsTypes.SET_NEW_ONLINE_USER_CONV,
  payload: userId,
});
export const refetchConversationsListStart = () => ({
  type: chatsTypes.REFETCH_CONVERSATIONS_LISTS_START,
});
